export function shouldFetchList(slice) {
  if (!slice) {
    return true;
  }
  return !slice.loaded && !slice.loading;
}
